import { useFormContext } from 'react-hook-form'

import { FIELD_NAMES } from '../validation'

export const useRemainBookValue = (bookValue: number) => {
  const { watch } = useFormContext()
  const impairedAmount = watch(FIELD_NAMES.impaired_amount, 0)

  return bookValue - impairedAmount
}
